<template>
  <el-dialog
    :title=" '确认送样' "
    :close-on-click-modal="false"
    :append-to-body="true"
    width="950px"
    :visible.sync="visible"
    @closed="reset">
    <!-- <el-form :model="dataForm" :rules="dataRule" ref="dataForm"  label-width="100px">
      <el-form-item label="送样凭证上传" prop="inputFile">
        <el-upload
          ref="upload"
          drag
          :action="url"
          :before-upload="beforeUploadHandle"
          :on-success="successHandle"
          :multiple="false"
          :limit="1"
          :file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">上传图片：支持jpg、jpeg、png格式；大小不超过100M</div>
        </el-upload>
      </el-form-item>
    </el-form> -->
    <el-table  class="mhide"
      :data="dataList"
      border
      v-loading="loading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;"
      :height="tableHeight">
      <!-- <el-table-column
        type="selection"
        header-align="center"
        align="center">
      </el-table-column> -->
      <el-table-column
        type="index"
        align="center"
        label="序号">
      </el-table-column>
      <el-table-column
        prop="hospCode"
        header-align="center"
        align="center"
        label="医院条形码">
      </el-table-column>
      <el-table-column
        prop="patientName"
        header-align="center"
        align="center"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="patientSex"
        header-align="center"
        align="center"
        label="性别">
        <template slot-scope="scope">
          <template v-for="item in options_patientSex">
            <template v-if="scope.row.patientSex == item.value">
              {{item.label}}
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        prop="patientAge"
        header-align="center"
        align="center"
        label="年龄">
      </el-table-column>
      <el-table-column
        prop="itemName"
        header-align="center"
        align="center"
        label="检验项目">
      </el-table-column>
      <el-table-column
        prop="sampleType"
        header-align="center"
        align="center"
        label="标本类型">
      </el-table-column>
      <el-table-column
        prop="sampleNum"
        header-align="center"
        align="center"
        label="标本数量">
      </el-table-column>
      <el-table-column
        prop="providerName"
        header-align="center"
        align="center"
        label="送检检验所">
      </el-table-column>
      <el-table-column
        prop="keshi"
        header-align="center"
        align="center"
        label="送检科室">
      </el-table-column>


      <el-table-column
        prop="orderStatus"
        header-align="center"
        align="center"
        label="订单确认">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.orderConfirmStatus === 0" size="small" type="warning">待确认</el-tag>
          <el-tag v-else-if="scope.row.orderConfirmStatus === 1" size="small" type="success">已确认</el-tag>
          <el-tag v-else-if="scope.row.orderConfirmStatus === 2" size="small" type="danger">已拒绝</el-tag>
          <el-tag v-else size="small" type="info">暂无</el-tag>
        </template>
      </el-table-column>

    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel()">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<style>
</style>

<script>
  import axios from 'axios'
  import {getCookie} from "../util/util";

  export default {
    props:[
      'confirmList'
    ],
    data () {
      return {
        url: '',
        visible: false,
        fileList: [],
        dataForm: {
          ids: [],
          filePath: ''
        },
        dataRule: {
        },
        dataList: [
          {
            hospCode: '111',
            patientName: 'DD'
          }
        ]
      }
    },
    methods: {
      init (ids) {
        this.visible = true
        this.dataForm.ids = ids
        this.url = process.env.API_ROOT + `/hpv/upload?token=${getCookie("_token")}`
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            axios.post("/jys/hospSample/confirmSendSample",{
              'ids': JSON.stringify(this.dataForm.ids),
              'sendSampleFilePath': this.dataForm.filePath
            }).then((res) => {
              if(res.data.code == 0){
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              }
            })
          }
        })
      },
      // 上传之前
      beforeUploadHandle (file) {
        if (!file.name.endsWith('jpg') && !file.name.endsWith('jpeg')&& !file.name.endsWith('png')) {
          this.$message.error('只支持jpg、jpeg、png格式文件！')
          return false
        }
      },
      // 上传成功
      successHandle (response, file, fileList) {
        this.fileList = fileList
        if (response && response.code === 0) {
          this.dataForm.filePath = response.url
        } else {
          this.$message.error(response.msg)
        }
      },

      //取消
      cancel(){
        this.visible = false
        this.reset()
      },

      //重置，将其值重置为初始值并移除校验结果
      reset(){
        // this.$refs['upload'].clearFiles()
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/confirm-send-sample.vue